import {devLog} from "../../../../utils/devLog/devLog";
import axios from "axios";

export default async(job: string, language: string) => {
  try {
    
    await axios.post(`${process.env.REACT_APP_API_URL}/data/job`, {job, language
    }, {withCredentials: true});
  
  } catch(error) {
    
    devLog(error);
  }
}